module.exports = __webpack_public_path__ + "img/camps-light.8d0643de.svg";